import { motion, useScroll, useSpring } from "framer-motion";

export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });
  return (
    <motion.div
      className="fixed left-0 top-0 z-[9997] h-[3px] w-full origin-left bg-gradient-to-r from-hars-orange to-hars-orangeLight"
      style={{ scaleX }}
      data-testid="scroll-progress"
      aria-hidden="true"
    />
  );
}
